import React, { Component } from "react";
import { Table, Button, Col, Tooltip, Row, Modal, DatePicker } from "antd";
import axios from "axios";
import "./Pages.css";
import TituloLiquidarForm from '../components/TituloLiquidarForm';
import CaixaTransferenciaForm from '../components/CaixaTransferenciaForm';
import CaixaCadListaForm from '../components/CaixaCadListaForm';
import TituloFiltroForm from '../components/TituloFiltroForm';
import CaixaPrintModal from "../relatorios/CaixaPrintModal";
import moment from "moment-timezone";
import numeral from "numeral";
import { getUsuario, getTemPermissao } from "../utils/LoginManager";
import InputForm from "../components/InputForm";
import { maskDate } from "../utils/Masker";
import Colors from '../utils/Colors';
import RelCaixa from '../tutoriais/RelCaixa';

const dateFormat = 'DD/MM/YYYY'
const { RangePicker } = DatePicker;
const { Column } = Table;

export default class extends Component {
  state = {
    listaRegistros: [],
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,
    formVisivel: false,
    formFiltroVisivel: false,
    formLiqVisivel: false,
    formTransfVisivel: false,
    formCadListafVisivel: false,

    vlrInicial: 0,
    vlrCred: 0,
    vlrDeb: 0,
    vlrFinal: 0,
    situacaoCaixa: '',

    registroParc: [],

    registroCaixas: {
      primeiroCarregamento: false,
      cx_data: moment().format('DD/MM/YYYY'),
      cx_cta_corrente: { key: '', label: '', },
    },

    filtros: {
      tipoTela: 'CX',
      buscaOrdem: { campo: 'tpp_data_pagto', ordem: 'ASC' },
      buscaDataIni: moment().format('DD/MM/YYYY'),
      buscaDataFim: moment().format('DD/MM/YYYY'),
      buscaControle: '',
      buscaNumero: '',
      buscaDescricao: '',
      buscaTipo: { key: 'X', },
      buscaSituacao: { key: 'X', },
      buscaPessoa: { key: '0' },
      buscaPlanoCta: { key: '0' },
      buscaCtaCorrente: { key: '0' },
      buscaTipoDoc: { key: '0' },
    }

  };

  componentDidMount() {
    const usuario = getUsuario();
    const { filtros } = this.state;
    filtros.buscaCtaCorrente = {
      key: String(usuario.par_cta_corrente_padrao),
      label: usuario.cc_descricao,
    }
    this.setState({
      usuario,
      filtros,
    }, this.getListaRegistros);
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }


  getListaRegistros = () => {
    this.setState({ listaRegistros: [], carregando: true });
    const { pagina, limite } = this.state;

    const { buscaDataIni, buscaDataFim, buscaNumero, buscaControle, buscaTipo,
      buscaPessoa, buscaPlanoCta, buscaCtaCorrente, buscaTipoDoc, buscaSituacao,
      buscaDescricao, buscaOrdem } = this.state.filtros;

    if ((buscaDataIni) && (buscaDataFim)) {

      let dataIni = '';
      if ((buscaDataIni) && (buscaDataIni !== undefined)) {
        dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
      }
      let dataFim = '';
      if ((buscaDataFim) && (buscaDataFim !== undefined)) {
        dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
      }

      axios
        .get('/titulos/listaCaixa', {
          params: {
            page: pagina,
            limite: limite,
            campoOrdem: buscaOrdem.campo,
            tipoOrdem: buscaOrdem.ordem,
            controle: buscaControle,
            numero: buscaNumero,
            descricao: buscaDescricao,
            tipo: buscaTipo.key,
            situacao: buscaSituacao.key,
            pessoa: buscaPessoa.key,
            ctaFin: buscaPlanoCta.key,
            tipoDoc: buscaTipoDoc.key,
            ctaCorrente: buscaCtaCorrente.key,
            dataIni,
            dataFim,
          }
        })
        .then(response => {
          const { data, total, current_page, per_page } = response.data;
          this.setState({
            listaRegistros: data,
            carregando: false,
            total: total,
            pagina: current_page,
            limite: Number(per_page),
          },
            this.getSaldos()
          );

        })
        .catch(erro => {
          console.warn(erro);
          this.setState({
            carregando: false,
          });
        });
    } else {
      this.setState({
        listaRegistros: [],
        carregando: false,
      });
    }
  };

  getSaldos = () => {
    this.setState({ vlrInicial: 0, vlrCred: 0, vlrDeb: 0, vlrFinal: 0, situacaoCaixa: '', });
    const { buscaDataIni, buscaDataFim, buscaNumero, buscaControle, buscaTipo,
      buscaPessoa, buscaPlanoCta, buscaCtaCorrente, buscaTipoDoc, buscaSituacao,
      buscaDescricao } = this.state.filtros;

    let dataIni = '';
    if ((buscaDataIni) && (buscaDataIni !== undefined)) {
      dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }
    let dataFim = '';
    if ((buscaDataFim) && (buscaDataFim !== undefined)) {
      dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }

    axios
      .get('/titulos/caixaSaldoInicial', {
        params: {
          controle: buscaControle,
          numero: buscaNumero,
          descricao: buscaDescricao,
          tipo: buscaTipo.key,
          situacao: buscaSituacao.key,
          pessoa: buscaPessoa.key,
          ctaFin: buscaPlanoCta.key,
          tipoDoc: buscaTipoDoc.key,
          ctaCorrente: buscaCtaCorrente.key,
          dataIni,
          dataFim
        }
      })
      .then(response => {
        this.setState({
          situacaoCaixa: response.data.situacaoCaixa,
          vlrInicial: response.data.vlrInicial,
          vlrCred: response.data.vlrCred,
          vlrDeb: response.data.vlrDeb,
          vlrFinal: parseFloat(response.data.vlrInicial) + parseFloat(response.data.vlrCred) - parseFloat(response.data.vlrDeb),
        });
      })
      .catch(erro => {
        console.warn(erro);
      });
  };



  onCancelarCadListaClick = () => {
    this.setState({
      formCadListafVisivel: false
    })
  }

  onAbrirCadListaClick = registro => {
    this.setState({
      formCadListafVisivel: true,
      registroCaixas: {
        cx_data: moment().format('DD/MM/YYYY'),
        cx_cta_corrente: {
          key: String(this.state.usuario.par_cta_corrente_padrao),
          label: this.state.usuario.cc_descricao,
        },
      }
    })
  };


  onTransferenciaClick = () => {
    this.setState({
      formTransfVisivel: false,
    },
      this.getListaRegistros
    )
  };

  onCancelarTransfClick = () => {
    this.setState({
      formTransfVisivel: false
    })
  }

  onNovaTransferenciaClick = registro => {
    if ((!this.state.usuario.par_pc_transf_orig) ||
      (!this.state.usuario.par_pc_transf_dest) ||
      (!this.state.usuario.par_cond_pagto_padrao)
    ) {
      Modal.warning({ title: 'Aviso!', content: 'Não é possível fazer transferências, faltam cadastrar parâmetros.', });
      return;
    }

    this.setState({
      formTransfVisivel: true,
      registroSelecionado: {
        tit_data_emissao: moment().format('DD/MM/YYYY'),
        tit_valor: 0,
        tit_pessoa: { key: '', label: '', },
        tit_descricao: '',
        tit_tipo_doc: { key: '', label: '', },
        tparc_conta_corrente_orig: { key: '', label: '', },
        tparc_conta_corrente_dest: { key: '', label: '', },
      }
    })
  };



  onCancelarLiqClick = () => {
    this.setState({
      formLiqVisivel: false
    })
  }

  onVisualizarClick = registro => {
    this.setState({ carregando: true });
    axios
      .get('/titulos/showParcela', {
        params: {
          idf: registro.tit_idf,
          parc: registro.tpp_parcela,
        }
      })
      .then(response => {
        const { data } = response;
        data.tipoTela = 'CONS';
        this.setState({
          formLiqVisivel: true,
          registroParc: data,
          carregando: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };


  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { filtros } = this.state;
    filtros[id] = value;
    this.setState({
      [id]: value
    },
      this.getListaRegistros
    );
  };

  onChangePeriodo = event => {
    const { filtros } = this.state;
    if (event[0]) {
      filtros.buscaDataIni = moment(event[0]._d).format('DD/MM/YYYY');
      filtros.buscaDataFim = moment(event[1]._d).format('DD/MM/YYYY');
    } else {
      filtros.buscaDataIni = moment().format('DD/MM/YYYY');
      filtros.buscaDataFim = moment().format('DD/MM/YYYY');
    }
    this.setState({
      filtros
    },
      this.getListaRegistros
    );
  };

  onAbrirFiltroClick = () => {
    this.setState({
      formFiltroVisivel: true,
      filtros: {
        tipoTela: this.state.filtros.tipoTela,
        buscaOrdem: this.state.filtros.buscaOrdem,
        buscaDataIni: this.state.filtros.buscaDataIni,
        buscaDataFim: this.state.filtros.buscaDataFim,
        buscaNumero: String(this.state.filtros.buscaNumero),
        buscaControle: String(this.state.filtros.buscaControle),
        buscaDescricao: String(this.state.filtros.buscaDescricao),
        buscaTipo: this.state.filtros.buscaTipo,
        buscaSituacao: this.state.filtros.buscaSituacao,
        buscaPessoa: this.state.filtros.buscaPessoa,
        buscaPlanoCta: this.state.filtros.buscaPlanoCta,
        buscaCtaCorrente: this.state.filtros.buscaCtaCorrente,
        buscaTipoDoc: this.state.filtros.buscaTipoDoc,
      }
    })
  };

  onFiltrarClick = (filtros) => {
    this.setState({
      formFiltroVisivel: false,
      filtros,
    },
      this.getListaRegistros(filtros)
    )
  };

  onCancelarFiltroClick = () => {
    this.setState({
      formFiltroVisivel: false,
    })
  };






  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      return (
        <span></span>
      )
    }
  }


  renderAcoes = (text, registro) => {
    return (
      <Tooltip title="Visualizar">
        <Button type="ghost" size="small" onClick={() => this.onVisualizarClick(registro)} icon="eye-o" />
      </Tooltip>
    );
  };

  renderValor = (vlr) => {
    return (
      <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
    );
  };

  renderValorCred = (registro) => {
    if (registro.pc_tipo === 'E') {
      return (
        <span> {numeral(parseFloat(registro.tpp_valor)).format('0,000.00')} </span>
      );
    } else {
      return (
        <span>-</span>
      );
    }
  };

  renderValorDeb = (registro) => {
    if (registro.pc_tipo === 'S') {
      return (
        <span> {numeral(parseFloat(registro.tpp_valor)).format('0,000.00')} </span>
      );
    } else {
      return (
        <span>-</span>
      );
    }
  };

  renderHistorico = (tit_descricao, registro) => {
    return (
      <Tooltip>{'[' + registro.pes_nome + '] ' + tit_descricao}</Tooltip>
    );
  };

  renderCtaFin = (pc_abreviatura, registro) => {
    return (
      <Tooltip title={registro.pc_descricao}>{pc_abreviatura}</Tooltip>
    );
  };



  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })


  onOrdenarListaClick = (column) => {
    const { filtros } = this.state;
    const ordem = filtros.buscaOrdem.campo && filtros.buscaOrdem.campo === column.dataIndex ? (filtros.buscaOrdem.ordem && filtros.buscaOrdem.ordem === 'ASC' ? 'DESC' : 'ASC') : 'ASC';
    filtros['buscaOrdem'] = { campo: column.dataIndex, ordem };
    this.setState({
      filtros,
      pagina: 1,
    }, this.getListaRegistros)
  };

  renderTitulo = (col) => {
    return (
      <Tooltip title="Clique para Ordenar"><div style={{ background: "#ececec", cursor: 'pointer', padding: 2, marginLeft: -5, marginRight: -5 }}>{col}</div></Tooltip>
    );
  };


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, registroParc,
      formFiltroVisivel, formLiqVisivel, formTransfVisivel, formCadListafVisivel,
      filtros, total, pagina, limite,
    } = this.state;

    const { buscaDataIni, buscaDataFim } = this.state.filtros;

    // console.log('CaixasPage.this.state: ', this.state);

    return (
      <div className="contentRoutesContainer">
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span className="tituloPage">Caixa - Extrato de Conta Corrente</span>
          <div>
            <Tooltip title="Video de Ajuda">
              <Button
                type="primary"
                onClick={() => window.open('https://www.youtube.com/watch?v=Op8desSkMtA&list=PLpe5WZ31yjQa5k3LuG7hBzmY1J-mOW3zz&index=1', '_blank')}
                icon="youtube"
                className="botao-ajuda"
              ></Button>
            </Tooltip>
            <Tooltip title="Ajuda">
              <Button
                type="primary"
                onClick={() => this.setState({ modalOpen: true })}
                icon="question"
                className="botao-ajuda"
              ></Button>
            </Tooltip>
          </div>
        </div>
        <div className="divider-page" />

        <Row>
          <div className="pageFiltro" style={{ height: 20 }}>

            <Row>
              <Col xs={6} style={{ marginRight: 10 }}>
                <span>Período</span>
                <RangePicker
                  style={{ width: "100%" }}
                  masker={maskDate}
                  value={[moment(buscaDataIni, dateFormat), moment(buscaDataFim, dateFormat)]}
                  format={dateFormat}
                  allowClear={false}
                  onChange={this.onChangePeriodo}
                />
              </Col>

              <Col xs={2} style={{ width: 110, marginTop: 20 }}>
                <Button
                  type="primary"
                  onClick={this.onAbrirFiltroClick}
                  className="botao-primary"
                  style={{ marginRight: 15 }}
                >
                  Filtrar
                </Button>
              </Col>

              <Col xs={2} style={{ width: 110, marginTop: 20 }}>
                <CaixaPrintModal
                  filtros={filtros}
                  situacaoCaixa={this.state.situacaoCaixa}
                  vlrInicial={this.state.vlrInicial}
                  vlrCred={this.state.vlrCred}
                  vlrDeb={this.state.vlrDeb}
                  vlrFinal={this.state.vlrFinal}
                  ctaCorrente={this.state.filtros.buscaCtaCorrente}
                  periodo={this.state.filtros.buscaDataIni + ' a ' + this.state.filtros.buscaDataFim}
                />
              </Col>

              {getTemPermissao('CaixasPage', 'editar') ? (
                <Col xs={2} style={{ width: 110, marginLeft: 40, marginTop: 20 }}>
                  <Button
                    type="primary"
                    onClick={this.onNovaTransferenciaClick}
                    className="botao-primary"
                    style={{ marginRight: 15, width: 120 }}
                  >
                    Transferência
                  </Button>
                </Col>
              ) : null}

              {getTemPermissao('CaixasPage', 'editar') ? (
                <Col xs={2} style={{ width: 110, marginLeft: 20, marginTop: 20 }}>
                  <Button
                    type="primary"
                    onClick={this.onAbrirCadListaClick}
                    className="botao-primary"
                    style={{ marginRight: 15 }}
                  >
                    Caixas
                  </Button>
                </Col>
              ) : null}

            </Row>


            <Row>
              <Col xs={24} md={24} style={{ height: 65, padding: 5, marginTop: 0 }}>
                <Col xs={24} md={6} style={{ height: 65, padding: 5 }}>
                  <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: Colors.fundoAzul }}>
                    <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                      <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.accentLight }}>
                        Saldo Inicial
                      </span>
                    </Row>
                    <Row style={{ textAlign: "center" }}>
                      <Row style={{ marginTop: -5 }}>
                        <span style={{ fontSize: 14, fontWeight: "bold", color: Colors.textOnPrimary }}>{this.renderValor(this.state.vlrInicial)}</span>
                      </Row>
                    </Row>
                  </div>
                </Col>
                <Col xs={24} md={6} style={{ height: 65, padding: 5 }}>
                  <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: Colors.fundoVerde }}>
                    <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                      <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.accentLight }}>
                        Entradas
                      </span>
                    </Row>
                    <Row style={{ textAlign: "center" }}>
                      <Row style={{ marginTop: -5 }}>
                        <span style={{ fontSize: 14, fontWeight: "bold", color: Colors.textOnPrimary }}>{this.renderValor(this.state.vlrCred)}</span>
                      </Row>
                    </Row>
                  </div>
                </Col>
                <Col xs={24} md={6} style={{ height: 65, padding: 5 }}>
                  <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: Colors.fundoVermelho }}>
                    <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                      <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.accentLight }}>
                        Saídas
                      </span>
                    </Row>
                    <Row style={{ textAlign: "center" }}>
                      <Row style={{ marginTop: -5 }}>
                        <span style={{ fontSize: 14, fontWeight: "bold", color: Colors.textOnPrimary }}>{this.renderValor(this.state.vlrDeb)}</span>
                      </Row>
                    </Row>
                  </div>
                </Col>
                <Col xs={24} md={6} style={{ height: 65, padding: 5 }}>
                  <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: Colors.fundoAzul }}>
                    <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                      <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.accentLight }}>
                        Saldo Final
                      </span>
                    </Row>
                    <Row style={{ textAlign: "center" }}>
                      <Row style={{ marginTop: -5 }}>
                        <span style={{ fontSize: 14, fontWeight: "bold", color: Colors.textOnPrimary }}>{this.renderValor(this.state.vlrFinal)}</span>
                      </Row>
                    </Row>
                  </div>
                </Col>

              </Col>

            </Row>



            <TituloFiltroForm
              visivel={formFiltroVisivel}
              onFiltrarClick={this.onFiltrarClick}
              onCancelarFiltroClick={this.onCancelarFiltroClick}
              filtros={filtros}
            />

            <TituloLiquidarForm
              visivel={formLiqVisivel}
              onCancelarLiqClick={this.onCancelarLiqClick}
              registroParc={registroParc}
            />

            <CaixaTransferenciaForm
              visivel={formTransfVisivel}
              onTransferenciaClick={this.onTransferenciaClick}
              onCancelarTransfClick={this.onCancelarTransfClick}
            />

            <CaixaCadListaForm
              visivel={formCadListafVisivel}
              onCancelarCadListaClick={this.onCancelarCadListaClick}
              registroCaixas={this.state.registroCaixas}
            />

            <RelCaixa
              isOpen={this.state.modalOpen}
              onClose={() => this.setState({ modalOpen: false })}
            />
          </div>
        </Row>

        <Row>
          <div style={{ marginTop: 10 }}>
            <Table
              pagination={{
                total: total,
                pageSize: limite,
                current: pagina,
                pageSizeOptions: ['10', '20', '30', '40', '50'],
                showSizeChanger: true,
              }}
              onChange={this.onTabelaChange}
              loading={{
                spinning: carregando,
                tip: 'Carregando. Aguarde...',
                size: "large"
              }}
              dataSource={listaRegistros}
              rowKey={(registro => registro.tit_idf + '_' + registro.tparc_parcela)}
            >
              <Column
                key="tpp_data_pagto"
                dataIndex="tpp_data_pagto"
                title={this.renderTitulo("Data")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderData}
                width={90}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="pc_abreviatura"
                dataIndex="pc_abreviatura"
                title={this.renderTitulo("Conta")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                width={60}
                align="left"
                className="listaCadastro"
                render={this.renderCtaFin}
              />
              <Column
                key="td_descricao"
                dataIndex="td_descricao"
                title={this.renderTitulo("Tipo Documento")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                width={100}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="tit_controle"
                dataIndex="tit_controle"
                title={this.renderTitulo("Controle")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                width={60}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="tit_numero"
                dataIndex="tit_numero"
                title={this.renderTitulo("Número")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                width={60}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="tit_descricao"
                dataIndex="tit_descricao"
                title={this.renderTitulo("Histórico")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                width={150}
                align="left"
                className="listaCadastro"
                render={this.renderHistorico}
              />
              <Column
                key=""
                dataIndex=""
                title={this.renderTitulo("Crédito")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderValorCred}
                width={70}
                align="right"
                className="listaCadastro"
              />
              <Column
                key=""
                dataIndex=""
                title={this.renderTitulo("Débito")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderValorDeb}
                width={70}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="acoes"
                title={<div style={{ background: "#ececec", padding: 2, marginLeft: -5, marginRight: -5 }}>.</div>}
                render={this.renderAcoes}
                width={40}
                align="center"
                className="listaCadastro"
              />
            </Table>
          </div>
        </Row>
      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/CaixasPage.js